import { render, staticRenderFns } from "./WillFuneral.vue?vue&type=template&id=25e61d5d"
import script from "./WillFuneral.vue?vue&type=script&lang=js"
export * from "./WillFuneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports